import React, { useState } from 'react';
import { ChromePicker } from 'react-color';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import { SmallHeader } from '../../index.js';
import q from '@debbie/cortex/dist/query.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { collectorsEntity } from '@debbie/cortex/dist/collectors/index.js';
const ColorUpdater = (props) => {
    const { id, theme } = props;
    if (!id)
        return null;
    const [color, setColor] = useState({
        // @ts-ignore
        hex: (theme && theme[props.entity]) || props.defaultColor,
    });
    const [tId, setTId] = useState(null);
    const updateTheme = async (e) => {
        setColor(e);
        if (tId)
            clearTimeout(tId);
        setTId(setTimeout(async () => {
            try {
                await collectorsAPI.update(id, {
                    theme: {
                        COLOR_ACCENT: theme && theme.COLOR_ACCENT,
                        COLOR_PRIMARY: theme && theme.COLOR_PRIMARY,
                        COLOR_SECONDARY: theme && theme.COLOR_SECONDARY,
                        ...{ [props.entity]: e.hex },
                    },
                });
                q.invalidate(keys.write.modify(collectorsEntity, id));
            }
            catch (error) {
                alert(error);
            }
        }, 300));
    };
    return (React.createElement("div", { style: { display: 'inline-block', paddingRight: '20px' } },
        React.createElement(SmallHeader, null, props.placeholder),
        // @ts-ignore
        React.createElement(ChromePicker, { width: "140px", color: color, onChange: updateTheme })));
};
export default ColorUpdater;
//# sourceMappingURL=ColorUpdater.js.map